<template>
	<header class='header' >
		<div class='header__logo' v-on:click="logoClick()">
			<icon name="logo" :size="{'height': '30px', 'width': '125px'}" v-if="production"  />
			<icon name="logoTest" :size="{'height': '30px', 'width': '125px'}" v-else  />
		</div>
		<div class="header__menu-item header__menu-item--status">
			<networkStatus />
		</div>
		<button class='header__menu-item--button button' v-on:click='toggleSendOrders()'>
			<icon name="sendOrders" class="button__icon" />
			<span class="button__label">{{resource('sendOrdersAndLists')}}</span>
		</button>
		<button class='header__menu-item--button button' v-on:click='toggleSidemenu()'>
			<icon name="menu" />
		</button>
		<sendOrders v-if="sendOrders" @close="toggleSendOrders()" />
	</header>
</template>

<style lang="scss">
.header {
  background: $header__bg;
  color: $header__color;
  align-items: stretch;
  padding: 0 0 0 $content;
  justify-content: flex-end;
  height: 47px;
  display: flex;
  font-size: $fs;
  flex: 0 0 auto;
  &__logo {
    margin-right: auto;
    align-self: center;
  }
  &__menu-item {
    padding: 0 $content;
    border-left: 1px solid $header__border;
    display: flex;
    &--button {
      @extend .button--no;
      @extend .header__menu-item;
      border-left: 1px solid $header__border !important;
    }
  }
}
</style>

<script>
import networkStatus from '@/components/networkStatus.vue'
import sendOrders from '@/components/app-sendOrders.vue'

export default {
	name: 'appHeader',
	components: {
		networkStatus,
		sendOrders
	},
	data() {
		return {
			sendOrders: false,
			res: {
				nl: {
					sendOrders: 'Verstuur open orders',
					sendOrdersAndLists: 'Verstuur open orders en bestellijsten',
				},
				fr: {
					sendOrders: 'Envoyer des commandes ouvertes',
					sendOrdersAndLists: 'Envoyer des commandes ouvertes et des listes de commandes',
				}
			}
		}
	},
	computed:{
		production(){
			return process.env.VUE_APP_ENV === 'Production'
		}
	},
	methods: {
		resource(item){
			var lang = this.$store.getters.language
			return this.res[lang][item]
		},
		logoClick() {
			var lastOrder = this.$store.getters.order
			if(lastOrder){
				this.$router.push({name:'order', params: { orderId: lastOrder.id, order: lastOrder }})
			}else{
				this.$router.push({name:'AddOrder'})
			}
		},
		toggleSidemenu() {
			this.$store.dispatch('toggleSidemenu')
		},
		toggleSendOrders() {
			this.sendOrders = !this.sendOrders
		},
	}
}
</script>
